import AuthRepository from './repositories/authRepository';
import CardRepository from './repositories/cardRepository';
import ConfigRepository from './repositories/configRepository';
import DataRepository from './repositories/dataRepository';
import SupervisorRepository from './repositories/supervisorRepository';
import SwipeRepository from './repositories/swipeRepository';
import ThemeRepository from './repositories/themeRepository';
import VideoRepository from './repositories/videoRepository';
import VirtualCardRepository from './repositories/virtualCardRepository';

export class Repository {
    constructor() {
        this.auth = new AuthRepository();
        this.cards = new CardRepository();
        this.config = new ConfigRepository();
        this.data = new DataRepository();
        this.supervisor = new SupervisorRepository();
        this.swipes = new SwipeRepository();
        this.themes = new ThemeRepository();
        this.video = new VideoRepository();
        this.virtualCards = new VirtualCardRepository();
    }
}

const singleton = new Repository();

export default singleton;